import { SubmitButton } from '@sravni/react-silent-authentication-form';
import { FORM_ID } from '../../../constants';
import { OTPScreenTexts } from '../OTPScreen.texts';

export const OTPScreenFooterMobile = () => (
    <SubmitButton size={52} form={FORM_ID}>
        {OTPScreenTexts.ContinueButtonLabel}
    </SubmitButton>
);
